import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import 'unfetch/polyfill/index.js'
import loadGoogleMapsApi from '@/loadGoogleMapsApi'
import VueGlide from 'vue-glide-js'
import 'vue-glide-js/dist/vue-glide.css'
import { mutations } from './store'
import md5 from 'crypto-js/md5'
import { getCookie, setCookie } from './utils'
const COOKIE_NAME = 'tt_mode'
Vue.use(VueGlide)

Vue.prototype.$lang = i18n

Vue.config.productionTip = false

Vue.prototype.$mapsEnabled = window.appData && window.appData.mapKey ? true : false

if (window.appData && window.appData.mapKey) {
  Vue.prototype.$loadMaps = loadGoogleMapsApi(window.appData.mapKey)
}

router.beforeEach((to, from, next) => {
  var searchMode = 'public'
  if (to.query.key) {
    if (md5(to.query.key).toString() == window.appData.searchKey) {
      searchMode = 'private'      
    }
    setCookie(COOKIE_NAME, searchMode)
  } else {
    const cookie = getCookie(COOKIE_NAME)
    if (cookie && ['private', 'public'].indexOf(cookie) > -1) {
      searchMode = cookie
    }
  }
  mutations.setSearchMode(searchMode)
  next()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
